import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "nc_user_token";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(KEY) || null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const api = () => axios.create({ baseURL: API, headers: token ? { Authorization: `Bearer ${token}` } : {} });

  useEffect(() => {
    if (!token) { setUser(null); setLoading(false); return; }
    api().get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem(KEY); setToken(null); setUser(null); })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(KEY, r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const signup = async (data) => {
    const r = await axios.post(`${API}/auth/signup`, data);
    localStorage.setItem(KEY, r.data.token);
    setToken(r.data.token);
    setUser(r.data.user);
    return r.data; // { token, user, welcome_coupon? }
  };

  const logout = () => {
    localStorage.removeItem(KEY);
    setToken(null);
    setUser(null);
  };

  const refresh = async () => {
    if (!token) return;
    try { const r = await api().get("/auth/me"); setUser(r.data); } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, signup, logout, refresh, api }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
